import React from "react";
import { MicrosoftLoginAgent } from "../../authentication/MicrosoftLoginAgent";
import { UMAuthAgent } from "../../authentication/UMAuthAgent";
import { Redirect } from "react-router";
import Spinner from "../Spinner";
import { connect } from "react-redux";
import { blue } from "@material-ui/core/colors";
import { routes } from "../../helper/routes";

class AuthResp extends React.Component {
  // Add a flag to track component mounting/unmounting
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      isFlowCancelled: false,
      termsAndConditions: "underReview",
      loading: true,
      umAuthAgentObj: new UMAuthAgent(),
    };
  }

  styles = {
    color: blue,
  };

  async componentDidMount() {
    this._isMounted = true; // Set the flag to true when the component is mounted

    // Check if user was redirected after login
    let token = await MicrosoftLoginAgent.GetTokenFromRedirect();
    if (token) return this.postLogin(token);
    return this.login();
  }

  componentWillUnmount() {
    this._isMounted = false; // Set the flag to false when the component is unmounted
  }

  async login() {
    try {
      await MicrosoftLoginAgent.login();
      if (this._isMounted) {
        // Check if the component is still mounted before updating the state
        this.setState({
          loading: false,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        // Check if the component is still mounted before updating the state
        this.setState({
          isFlowCancelled: true,
          loading: false,
        });
      }
    }
  }

  async postLogin(token) {
    try {
      await MicrosoftLoginAgent.GetDetailsFromToken(token);
      const UMAuthAgentObj = new UMAuthAgent();
      await UMAuthAgentObj.getUMUser();
      if (this._isMounted) {
        // Check if the component is still mounted before updating the state
        this.setState({
          umAuthAgentObj: UMAuthAgentObj,
          loading: false,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        // Check if the component is still mounted before updating the state
        this.setState({
          isFlowCancelled: true,
          loading: false,
        });
      }
    }
  }

  render() {
    if (!this.state.loading) {
      if (
        this.props.agreementStatus === "accepted"
        // && this.state.umAuthAgentObj.userType === "admin"
      ) {
      
        const fromURL = sessionStorage.getItem("fromURL");
        const employeeType = sessionStorage.getItem("employeeType");

        if (fromURL === routes.find_papers) {
          const candidateId = sessionStorage.getItem("enrolledPaper_candidateId");
          const enroll = sessionStorage.getItem("enroll_status");
          sessionStorage.removeItem("fromURL");
          // sessionStorage.removeItem("enrolledPaper_candidateId");
          return <Redirect
            to={{
              pathname: routes.find_papers,
              state: {
                value: 1,
                candidateStatus: enroll === "true" ? "Assigned" : "Finished",
                paperStatus: enroll === "true" ? "Not Started" : "Completed",
                candidateId: parseInt(candidateId),
              },
            }}
          />;
        } else {
          // if(employeeType && employeeType === "TEACH")
            // return <Redirect to={routes.view_assessment_review} />;
          return <Redirect to="/manage-dashboard" />;
        }
      }

      if (this.props.agreementStatus === "notYetReview") {
        return (
          <Redirect
            to={{
              pathname: routes.accept_terms,
              state: { userType: this.state.umAuthAgentObj.userType },
            }}
          />
        );
      }
      if (
        this.state.isFlowCancelled ||
        this.props.agreementStatus === "unaccepted"
      ) {
        return <Redirect to="/" />;
      }
      return <Spinner active={true} text="Logging In..." />;
    } else {
      return <Spinner active={true} text="Logging In..." />;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    agreementStatus: state.userAgreementReducer.status,
  };
};

const actionCreators = {};

const connectedAuthRespPage = connect(
  mapStateToProps,
  actionCreators
)(AuthResp);

export { connectedAuthRespPage as AuthResp };
